import React from 'react';

import { cn } from '@/lib/utils';

interface RainmakerLogoProps {
  size?: number;
  className?: string;
}

export const RainmakerLogo: React.FC<RainmakerLogoProps> = ({
  size = 24,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={cn('inline-block', className)}
      fill="currentColor"
    >
      <g transform="translate(0,0)">
        <path d="M256.006 25c-27.04.067-43.934 10.558-55.055 24.63C189.83 63.708 185 81.973 185 96c0 11.5 10.2 26.6 22.2 42.6 9.324 12.433 19.665 25.43 23.831 40.22 8.793 2.696 17.182 4.18 24.969 4.18 8.03 0 16.701-1.578 25.795-4.436-3.689-5.844-6.62-11.87-8.43-18.025-3.948-13.423-2.203-28.427 8.272-38.902l1.502-1.504 80.257-26.752c-16.048-11.23-33.595-25.516-50.709-38.207-23.052-17.095-46.165-30.17-56.681-30.174zM253 48.223c10.302 0 18.777 8.475 18.777 18.777 0 10.302-8.475 18.777-18.777 18.777-10.302 0-18.777-8.475-18.777-18.777 0-10.302 8.475-18.777 18.777-18.777zm-215.092 2.83C35.136 72.677 35.747 95.657 39.232 119H64v18H42.47c6.08 28.964 16.338 58.097 29.817 85.535l50.313-37.734 10.8 14.398-52.683 39.512a376.877 376.877 0 0 0 10.902 18.5c11.234 17.872 23.787 34.448 37.258 49.185l56.76-56.76 12.726 12.727-56.955 56.955c22.977 22.282 48.1 39.158 73.592 48.22V253.452l32.52-52.844c-42.386-3.85-87.479-35.576-127.377-69.775-35.53-30.454-63.867-60.62-82.235-79.781zm436.184 0c-18.368 19.16-46.705 49.327-82.235 79.781-39.898 34.199-84.991 65.926-127.377 69.775L297 253.453v114.084c25.493-9.06 50.615-25.937 73.592-48.219l-56.955-56.955 12.726-12.726 56.76 56.76c13.47-14.738 26.024-31.314 37.258-49.186a376.87 376.87 0 0 0 10.902-18.5L378.6 199.199l10.8-14.398 50.313 37.734c13.48-27.438 23.737-56.57 29.816-85.535H448v-18h24.768c3.485-23.343 4.096-46.323 1.324-67.947zM256 221.172l-23 37.375V495h46V258.547l-23-37.375z" />
      </g>
    </svg>
  );
};
